export const getApiErrorMessage = (error: unknown, fallback = 'Something went wrong!'): string => {
  if (typeof error === 'string' && error.trim()) {
    return error;
  }

  if (!error || typeof error !== 'object') {
    return fallback;
  }

  const apiError = error as {
    message?: unknown;
    response?: {
      data?: {
        message?: unknown;
      };
    };
  };
  const responseMessage = apiError.response?.data?.message;

  if (typeof responseMessage === 'string' && responseMessage.trim()) {
    return responseMessage;
  }

  if (typeof apiError.message === 'string' && apiError.message.trim()) {
    return apiError.message;
  }

  return fallback;
};

export default getApiErrorMessage;
